import React from 'react'
//=======Material UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import useTerminateProject from './useAdverseEvent'
import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import useCheckPermission from '../../../../../utilities/checkPermission'
import Dialog from '../../../../../control/dialog/dialog'
import Button from '../../../../../control/button/button'
import useTranslate from '../../../../../i18n/useTranslate'

import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

type RequestNewProjectViewType = ReturnType<typeof useTerminateProject> & Omit<RequestProjectRenewalType, 'projectMode'>
const RequestProjectRenewalView: React.FC<RequestNewProjectViewType> = (props) => {
    const {
        projectMode,
        isViewMode,
        configDialog,
        projectData,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer callbackSaveComplete={onCallbackSaveComplete} />
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>

            {isViewMode && !canUpdateDocument ? (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}

            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}

export type RequestProjectRenewalType = {
    projectMode: 'CREATE' | 'EDIT'
}
const RequestProjectRenewal: React.FC<RequestProjectRenewalType> = (props) => {
    const requestProjectRenewalModel = useTerminateProject(props)
    return <RequestProjectRenewalView {...requestProjectRenewalModel} />
}
export default RequestProjectRenewal
